var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradeC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 33,
    rx: 5.5,
    fill: "#FEF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.358 23.216C17.122 23.216 16.054 22.946 15.154 22.406C14.266 21.854 13.576 21.092 13.084 20.12C12.592 19.136 12.346 17.996 12.346 16.7C12.346 15.416 12.592 14.288 13.084 13.316C13.576 12.332 14.266 11.564 15.154 11.012C16.054 10.46 17.122 10.184 18.358 10.184C19.798 10.184 20.968 10.532 21.868 11.228C22.78 11.912 23.362 12.872 23.614 14.108H21.94C21.748 13.328 21.352 12.704 20.752 12.236C20.164 11.756 19.366 11.516 18.358 11.516C17.458 11.516 16.672 11.726 16 12.146C15.328 12.554 14.806 13.148 14.434 13.928C14.074 14.696 13.894 15.62 13.894 16.7C13.894 17.78 14.074 18.71 14.434 19.49C14.806 20.258 15.328 20.852 16 21.272C16.672 21.68 17.458 21.884 18.358 21.884C19.366 21.884 20.164 21.656 20.752 21.2C21.352 20.732 21.748 20.114 21.94 19.346H23.614C23.362 20.558 22.78 21.506 21.868 22.19C20.968 22.874 19.798 23.216 18.358 23.216Z",
    fill: "#DC2626"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 33,
    rx: 5.5,
    stroke: "#FECACA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradeC);
export default __webpack_public_path__ + "static/media/grade_c.98e5ccbf1acb2f54cca55b48a234ba79.svg";
export { ForwardRef as ReactComponent };